import React from "react";
import { Box } from "@mui/material";

const AudioPlayer = ({ audioSrc }) => {
  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <audio
        controls
        style={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          height: "40px",
          borderRadius: 5,
        }}
      >
        <source src={audioSrc} type="audio/ogg;codecs=opus" />
        <source src={audioSrc} type="audio/webm;codecs=opus" />
        <source src={audioSrc} type="audio/webm" />
        <source src={audioSrc} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </Box>
  );
};

export default AudioPlayer;
